import { isValidEmail } from 'Shared/helpers';
import removeAccents from 'remove-accents';
import { isURL } from 'validator';

const validNameChars = /^([a-zA-Z]|[,.'-])+$/u;

export const exists = (v) => v != false || 'Required';
export const isEmail = (v) =>
  isValidEmail(v) || 'Please enter a valid email address';
export const isUrl = (v) => {
  if (!(v.startsWith('http://') || v.startsWith('https://'))) {
    return 'Must start with http:// or https://';
  }
  if (!isURL(v)) return 'Please enter a valid URL';
  return true;
};

export const invalidNameMessage = (v) => {
  if (!removeAccents(v).match(validNameChars)) {
    return 'Invalid character(s) entered';
  }

  return true;
};

/**
 * Validates that a value is of a minimum length.
 * Passing a field name as the second argument returns a field-specific error message.
 * @callback
 * @param {number} length
 * @param {string} [field]
 * @returns {(v: number) => boolean | string} function that returns true or validation error message
 */
export const minLength = (length, field) => (v) =>
  v.length >= length ||
  `${field ? `${field} m` : 'M'}ust be ${length}+ characters`;
